import { render, staticRenderFns } from "./AccountResetDone.vue?vue&type=template&id=7c99fffe"
import script from "./AccountResetDone.vue?vue&type=script&lang=js"
export * from "./AccountResetDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports